import { render, staticRenderFns } from "./newNote.vue?vue&type=template&id=f1ba17d0&scoped=true&"
import script from "./newNote.vue?vue&type=script&lang=js&"
export * from "./newNote.vue?vue&type=script&lang=js&"
import style0 from "./newNote.vue?vue&type=style&index=0&id=f1ba17d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ba17d0",
  null
  
)

export default component.exports